import Articles from "../components/news/opArt"
import SpotLights from "../components/news/spotLights"
import SectionPaginator from "../components/sectionPaginator"
import { PropTypes } from 'prop-types';
import { DecodeHtml } from "../utils/decodeHtml";
import { retrunAssets } from "../utils/getAssets";

const OpinionArticle = ({ events }) => {



    const title = events?.opinionArticlesTitle
    const articles = events?.articles?.items?.map(item => {
        item = item?.content?.properties
        return (
            {
                title: item?.title,
                content: DecodeHtml({ html: item?.articlesDescription?.markup }),
                img: item?.articleImage != null ? retrunAssets(item?.articleImage[0]?.url) : "",
                date: item?.publishDate,
                author: item?.author,
                seeMore: item?.seeMore != null ? item?.seeMore[0].url : ""
            }
        )
    })
   

    const itemsPerPage = 4
    const length = articles?.length || 0
    const dataToShow = length > itemsPerPage ? length / itemsPerPage : 1

    const data =
        Array.from({ length: dataToShow }, (_, i) =>
            <Articles articles={articles?.slice(i * itemsPerPage, i * itemsPerPage + itemsPerPage)} key={i} />
        )


    return (
        <div className="relative bg-white  py-8 text-black w-full md:px-32 p-6 flex flex-col items-center justify-center ">

            <div className="flex items-center justify-center w-full h-full">
                <div className="grid grid-cols-1 xl:grid-cols-[80%_17%] gap-16 w-full ">
                    <SectionPaginator heading={title} contents={data} />
                    <SpotLights events={events} />
                </div>
            </div>

        </div>
    )
}
OpinionArticle.propTypes = {
    events: PropTypes.object
}
export default OpinionArticle